import * as form from '../form';

export const foreignActivitiesCurrent = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        PersonType: form.radio(xitem.PersonType),
        Name : form.name(xitem.Name),
        BenefitType: form.radio(xitem.BenefitType),
        BenefitTypeExplanation: form.textarea(xitem.BenefitTypeExplanation),
        BenefitNature: form.branch(xitem.BenefitNature),
        BenefitDate: form.datecontrol(xitem.BenefitDate), 
        DollarValue: form.number(xitem.DollarValue), 
        Reason: form.textarea(xitem.Reason),
        StartDate: form.datecontrol(xitem.StartDate),
        EndDate: form.datecontrol(xitem.EndDate),
        BenefitFrequency: form.radio(xitem.BenefitFrequency),
        BenefitFrequencyExplanation:form.textarea(xitem.BenefitFrequencyExplanation),
        TotalBenefitsValue :form.number(xitem.TotalBenefitsValue),
        ReceivingReason :form.textarea(xitem.ReceivingReason),
        FuturePlans: form.branch(xitem.FuturePlans),
        FuturePlansExplanation :form.textarea(xitem.FuturePlansExplanation),
        BenefitCountry:form.country(xitem.BenefitCountry),
        BenefitObligated : form.branch(xitem.BenefitObligated),
        ObligatedExplanation :form.textarea(xitem.ObligatedExplanation),
        NotObligatedExplanation :form.textarea(xitem.NotObligatedExplanation),
      },
    };
  });
  return {
    HasCurrentActivity: form.branch(data.HasCurrentActivity),
    List: form.collection(items, (data.List || {}).branch),
  };
};
